<template>
  <section id="researchers" class="researchers" ref="researchersSection">
    <div class="container">
      <header class="section-header">
        <SectionTitle>
          {{ $t("research.researchers.title") }}
        </SectionTitle>
        <div class="section-header__content">
          <p class="section-header__text">
            {{ $t("research.researchers.text") }}
          </p>
        </div>
      </header>

      <section class="researchers-list">
        <div
          v-for="researcher in filteredResearchers"
          :key="researcher.id"
          class="researcher"
        >
          <span class="num"></span>
          <div class="researcher-card">
            <figure class="researcher-figure">
              <img
                :src="researcher.image"
                :alt="researcher.name"
                loading="lazy"
              />
            </figure>

            <div class="researcher-info">
              <h3 class="researcher-name">{{ researcher.name }}</h3>
              <p class="researcher-title">
                {{ researcher.title }}
                <span v-if="researcher.company"
                  >at {{ researcher.company }}</span
                >
              </p>
            </div>
          </div>
          <div class="research-info">
            <h3 class="research__title">
              {{ researcher.textTitle }}
            </h3>
            <p>
              {{ researcher.text }}
            </p>
            <p v-if="researcher.downloadLink">
              <BaseButton
                :to="researcher.downloadLink"
                type="secondary"
                class="researcher__download"
                target="_blank"
              >
                {{ $t("research.researchers.download") }} <Download />
              </BaseButton>
            </p>
          </div>
        </div>
      </section>
      <section class="curator">
        <figure class="researcher-figure curator-figure">
          <img
            src="@/assets/images/speakers/dmytro-iarovyi.jpg"
            alt=""
            class=""
            loading="lazy"
          />
        </figure>

        <div class="curator-info">
          <h3 class="researcher-name">
            {{ $t("speakers.dmytroIarovyi.name") }}
          </h3>
          <p class="researcher-title">
            {{ $t("speakers.dmytroIarovyi.researchTitle") }}
          </p>
          <p>
            {{ $t("speakers.dmytroIarovyi.curatorText") }}
          </p>
          <p>
            <BaseButton
              to="/pdf/From_Curator.pdf"
              type="primary"
              class="researcher__download"
              target="_blank"
            >
              {{ $t("research.researchers.download") }} <Download />
            </BaseButton>
          </p>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import researchers from "@/data/researchers";
import SectionTitle from "@/components/common/SectionTitle.vue";
import BaseButton from "@/components/common/BaseButton.vue";
import { Download } from "lucide-vue-next";

export default {
  name: "researchersSection",
  components: {
    SectionTitle,
    BaseButton,
    Download,
  },
  data() {
    return {
      researchers,
    };
  },
  computed: {
    filteredResearchers() {
      return this.researchers.filter((researcher) => researcher.show);
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  /* gap: 5rem; */
  gap: clamp(2rem, 0.7228rem + 4.7525vw, 5rem);
}

.section-header {
  display: flex;
  flex-direction: column;
  /* gap: 4rem; */
  gap: clamp(1rem, -0.2772rem + 4.7525vw, 4rem);
}

.section-header__content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 522px;
  margin-left: auto;
}

.section-header__text {
  /* font-size: 1.25rem; */
  font-size: clamp(1rem, 0.8936rem + 0.396vw, 1.25rem);
  line-height: 1.5;
}

.researchers-list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  counter-reset: section;
  gap: clamp(3rem, 1.6163rem + 5.1485vw, 6.25rem);
}

.researcher,
.curator {
  width: 100%;
  display: flex;
  transition: transform 0.1s ease-out;
  text-decoration: none;
  padding: 1rem 0;
  flex-direction: column;
  gap: 2rem;
}
@media screen and (min-width: 768px) {
  .researcher {
    flex-direction: row;
    justify-content: space-between;
  }
  .curator {
    flex-direction: row;
    padding-left: 9.5%;
    padding-right: 10%;
  }
}

.researcher-card {
  width: 100%;
  gap: 2rem;
}

.researcher-figure {
  width: 100%;
  height: 357px;
  margin: 0 0 2rem;
  padding: 0;
  border-radius: 8px;
  background-color: var(--color-primary);
}

.curator-figure {
  max-width: 360px;
}

.researcher-figure img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}

.researcher-info,
.curator-info {
  display: flex;
  flex-direction: column;
  /* gap: 1rem; */
  gap: clamp(0.5rem, 0.2871rem + 0.7921vw, 1rem);
}

.researcher-name,
.curator-name {
  /* font-size: 2rem; */
  font-size: clamp(1rem, 0.5743rem + 1.5842vw, 2rem);
  line-height: 1.125;
  font-weight: 400;
  text-transform: uppercase;
  color: var(--color-off-black);
}
.researcher-title,
.curator-title {
  /* font-size: 1.75rem; */
  font-size: clamp(1rem, 0.6807rem + 1.1881vw, 1.75rem);
  line-height: 1.285;
  color: var(--color-primary);
}

.num {
  counter-increment: section;
  order: 0;
}
.num:after {
  color: var(--color-primary);
  font-weight: bold;
  content: counter(section) ".";
  font-size: clamp(2.625rem, 2.0396rem + 2.1782vw, 4rem);
}

.researcher-card {
  flex-direction: column;
  gap: 2rem;
  order: 1;
}
@media screen and (min-width: 768px) {
  .researcher-card {
    padding-left: 2rem;
    padding-right: 2rem;
    max-width: 420px;
  }
  .researcher:nth-child(even) .researcher-card {
    order: 2 !important;
  }
  .researcher:nth-child(even) .research-info {
    order: 1 !important;
    max-width: 660px;
  }
  .research-info {
    max-width: 568px;
  }
}

.research-info {
  color: var(--color-off-white);
  background-color: var(--color-primary);
  border-radius: var(--border-radius);
  padding: 2rem 1.5rem;
  gap: 2rem;
  display: flex;
  flex-direction: column;
  font-size: clamp(1rem, 0.8403rem + 0.5941vw, 1.375rem);
  line-height: 1.3;
  order: 2;
}

.researcher__download {
  line-height: 14px;
  display: inline-block;
}
.researcher__download svg {
  width: 1.25rem;
  height: 1.25rem;
  margin-left: 0.5rem;
  margin-top: -0.25rem;
  margin-bottom: -0.125rem;
}
</style>
